<template>
  <div>
    <div class="content">
      <div v-for="(rule, index) in localRules" :key="rule.id">
        <el-card class="container" body-style="width: 100%;padding: 0;">
          <div class="card-content">
            <div class="row-item">
              <div class="row-title">
                {{ ASSESSMENT_FIELD_LABELS[ASSESSMENT_FIELDS.NAME] }}:
              </div>
              <div class="row-content">
               <div class="mobile-category-wrapper">
                   <el-select v-model="rule.categoryId" filterable :allow-create="isSuperUser" default-first-option
                     placeholder="请选择关键指标" class="mobile-category-select"
                     @change="onCategoryChange(index, rule, $event)" :disabled="readonly || isFixedDimension(rule) || !isSuperUser">
                     <el-option v-for="item in categoryOptions" :key="item.id" :label="item.name" :value="item.id">
                       <span>{{ item.name }}</span>
                       <el-tag v-if="item.isAiItem" size="mini" type="warning"
                         style="float: right; margin-top: 5px">AI</el-tag>
                     </el-option>
                   </el-select>
                   <el-tag v-if="isCategoryAi(rule.categoryId)" size="mini" type="warning"
                     class="mobile-selected-ai-tag">AI</el-tag>
                   <el-tag v-if="isFixedDimension(rule)" size="mini" type="info"
                     class="mobile-selected-ai-tag" style="right: 60px;">固定</el-tag>
                 </div>
              </div>
            </div>
            <div class="row-item">
              <div class="row-title">
                {{ ASSESSMENT_FIELD_LABELS[ASSESSMENT_FIELDS.DESCRIPTION] }}:
              </div>
              <div class="row-content">
                <el-input
                  placeholder="请输入本月工作目标/计划"
                  type="textarea"
                  autosize
                  class="editable-input"
                  @input="
                    onInput(index, rule, ASSESSMENT_FIELDS.DESCRIPTION, $event)
                  "
                  :value="rule.description"
                  :disabled="readonly || isFixedDimension(rule)"
                />
              </div>
            </div>
            <div class="row-item">
              <div class="row-title">
                {{ ASSESSMENT_FIELD_LABELS[ASSESSMENT_FIELDS.STANDARD] }}:
              </div>
              <div class="row-content">
                <el-input
                  placeholder="请输入本月完成进度和需达到的标准"
                  type="textarea"
                  autosize
                  class="editable-input"
                  @input="
                    onInput(index, rule, ASSESSMENT_FIELDS.STANDARD, $event)
                  "
                  :value="rule.standard"
                  :disabled="readonly || isFixedDimension(rule)"
                />
              </div>
            </div>
            <div class="row-item">
              <div class="row-title">
                {{ ASSESSMENT_FIELD_LABELS[ASSESSMENT_FIELDS.WEIGHT] }}:
              </div>
              <div class="row-content">
                <el-input
                  placeholder="单项分值"
                  type="textarea"
                  autosize
                  class="editable-input"
                  @input="
                    onInput(index, rule, ASSESSMENT_FIELDS.WEIGHT, $event)
                  "
                  :value="rule.weight"
                  :disabled="readonly || isFixedDimension(rule) || !isSuperUser"
                />
              </div>
            </div>
            <div class="row-item" v-if="rule.dataSource">
              <div class="row-title">
                数据源:
              </div>
              <div class="row-content">
                <span style="color: #606266;">{{ rule.dataSource }}</span>
              </div>
            </div>

            <div class="row-btn">
              <el-button
                size="mini"
                type="danger"
                @click="onDelete(index, rule)"
                :disabled="readonly || isFixedDimension(rule)"
                >删除</el-button
              >
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ASSESSMENT_FIELDS,
  ASSESSMENT_FIELD_LABELS,
} from "@/constants/AssessmentField";

/**
/**
 * @typedef {Object} Item
 * @property {string } label
 * @property {string | number} value
 */

export default {
  name: "MobileCard",
  props: {
    rules: {
      type: Array,
      required: true,
    },
    categoryOptions: {
      type: Array,
      default: () => [],
    },
    isSuperUser: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "rules",
    event: "update-rules",
  },
  data() {
    return {
      ASSESSMENT_FIELDS,
      ASSESSMENT_FIELD_LABELS,
      localRules: this.rules,
    };
  },
  watch: {
    rules(val) {
      this.localRules = val;
    },
  },
  methods: {
    isCategoryAi(categoryId) {
      if (!categoryId) {
        return false;
      }
      const matched = this.categoryOptions.find((item) => item.id === categoryId);
      return !!(matched && matched.isAiItem);
    },
    isFixedDimension(rule) {
      return rule.isFixed === true;
    },
    onDelete(index, rule) {
      if (this.readonly) {
        return;
      }
      if (this.isFixedDimension(rule)) {
        this.$message.warning("固定考核指标不可删除");
        return;
      }
      this.$emit("delete-rule", index, rule);
    },
    updateRule(index, nextRule) {
      const nextRules = [...this.localRules];
      nextRules.splice(index, 1, nextRule);
      this.localRules = nextRules;
      this.$emit("update-rules", nextRules);
    },
    onCategoryChange(index, rule, value) {
      if (this.readonly || !this.isSuperUser) {
        return;
      }
      const matched = this.categoryOptions.find((item) => item.id === value);
      this.updateRule(index, { ...rule, categoryId: value, category: matched ? matched.name : "" });
      this.$emit("category-change", { index, value });
    },
    onInput(index, rule, field, value) {
      if (this.readonly) {
        return;
      }
      this.updateRule(index, { ...rule, [field]: value });
    },
  },
};
</script>
<style scoped lang="less">
.container {
  width: 100%;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  box-sizing: border-box;
}

.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: large;
  padding-bottom: 0.3rem;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.row {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.card-content {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}
.row-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.row-title {
  font-size: small;
  width: 20%;

  font-weight: bold;
}

.row-content {
  flex: 1;
  font-size: small;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 0.5rem;
}
.mobile-category-wrapper {
  width: 100%;
  position: relative;
}

.mobile-category-select {
  width: 100%;
}

.mobile-selected-ai-tag {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}
.row-btn {
  display: flex;
  justify-content: flex-end;
}
</style>
